module.exports = __webpack_public_path__ + "img/engine.a04f2d43.svg";